import { GenericLayout } from '@/components/layouts/GenericLayout/GenericLayout';
import { Head } from '@/components/seo/Head/Head';
import { GenericIconScreen } from '@/components/shared/GenericIconScreen/GenericIconScreen';
import { Button } from '@/components/ui/Button/Button';
import { paths } from '@/config/paths';
import { Link2Off } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export const LinkExpiredScreen = () => {
  const { t } = useTranslation('utils', {
    keyPrefix: 'linkExpiredScreen',
  });

  return (
    <GenericLayout>
      <Head title={t('seo.title')} />
      <GenericIconScreen
        Icon={Link2Off}
        title={t('title')}
        description={t('description')}
        role='alert'
        aria-live='assertive'
        leftActionElement={
          <Button className='w-full' asChild>
            <Link to={paths.home.path}>{t('button.label')}</Link>
          </Button>
        }
      />
    </GenericLayout>
  );
};
